$(document).ready(function () {
    $('.pick-choose').click(function (e) {
      var vid = $(this).attr('variant_id');
      $("#vid").val(vid);
    });
  
    document.querySelectorAll('.pick-choose').forEach(item => {
      item.addEventListener('click', function() {
        let radioButton = item.querySelector('input[type="radio"]');
        radioButton.checked = true; // Set radio button to checked
      });
    });
  });

// var monthly_plan = 46898132320477;
// var six_month_plan = 46898131271901;
// var one_year_plan = 43813033836765;
// var two_year_plan = 46898130747613;

var monthly_plan = 44283189100765;
var six_month_plan = 44283209777373;
var one_year_plan = 43813033836765;
var two_year_plan = 43879658946781;

var activation_fee_variant = 43795278954717;
var watch_variant = 47039507726557;

async function addProduct() {
   
    $("#continue_btn").prop('disabled', true);
    var v_id = $("#vid").val();
   
    
  if (v_id == monthly_plan) {
    var selling_plan = 6317867229;
  } else if (v_id == six_month_plan) {
    var selling_plan = 5220270301;
  } else if (v_id == one_year_plan) {
    var selling_plan = 5220401373;
  } else if (v_id == two_year_plan) {
    var selling_plan = 5219877085;
  }
    
    //alert(curr_watch_variant);
     jQuery.post("/cart/clear.js").done(function () {
      
        jQuery.post('/cart/update.js', {
            updates: {
              44283189100765: 0,
              44283209777373: 0,
              43813033836765: 0,
              43879658946781: 0
            }
          }).done(function () {
           
              jQuery.post("/cart/add.js", {
          items: [
            {
              quantity: 1,
              id: watch_variant,
            },
            {
                quantity: 1,
                id: v_id,
                selling_plan: selling_plan,
            },
            {
              quantity: 1,
              id: activation_fee_variant, 
              
          },
          ],
        })
        .done(function () {
            setTimeout(() => {
            $("#continue_btn").prop('disabled', false);
          
            }, 3000);
   
          window.location.href = "/pages/winback-cosmo-care";
        });
    });
});

  }
  